$.fn.ProfileForm = function() {
  let self = this
  self.shipping_toggle = $('input[name="shipping_same_as_billing"]')
  self.website_toggle = $('input[name="boutique_online"]')
  self.affichettes_toggle = $('input[name="affichettes_option"]')
  self.company_type_autre = $('input[name="company_type[]"][value="autre"]')

  if (self.data('profile-form')) {
    return self.data('profile-form')
  }

  self.show_shipping_fields = function() {
    $('.field-container--shipping_address').slideDown('fast')
    $('.field-container--shipping_city').slideDown('fast')
    $('.field-container--shipping_postal_code').slideDown('fast')
  }

  self.hide_shipping_fields = function() {
    $('.field-container--shipping_address').slideUp('fast')
    $('.field-container--shipping_city').slideUp('fast')
    $('.field-container--shipping_postal_code').slideUp('fast')
  }

  self.show_website_field = function() {
    $('.field-container--boutique_url').slideDown('fast')
  }

  self.hide_website_field = function() {
    $('.field-container--boutique_url').slideUp('fast')
  }

  self.show_affichettes_dimensions_field = function() {
    $('.field-container--affichettes_dimensions').slideDown('fast')
  }

  self.hide_affichettes_dimensions_field = function() {
    $('.field-container--affichettes_dimensions').slideUp('fast')
  }

  self.show_type_revendeur_field = function() {
    $('.field-container--type_revendeur').slideDown('fast')
  }

  self.hide_type_revendeur_field = function() {
    $('.field-container--type_revendeur').slideUp('fast')
  }

  self.check_shipping_toggle = function() {
    if (self.shipping_toggle.prop('checked')) {
      self.hide_shipping_fields()
    } else {
      self.show_shipping_fields()
    }
  }

  self.check_website_toggle = function() {
    if (self.website_toggle.filter(':checked').val() === 'oui') {
      self.show_website_field()
    } else {
      self.hide_website_field()
    }
  }

  self.check_affichettes_toggle = function() {
    if (self.affichettes_toggle.filter(':checked').val() === 'oui') {
      self.show_affichettes_dimensions_field()
    } else {
      self.hide_affichettes_dimensions_field()
    }
  }

  self.check_company_type_toggle = function() {
    if (self.company_type_autre.prop('checked')) {
      self.show_type_revendeur_field()
    } else {
      self.hide_type_revendeur_field()
    }
  }

  self.initialize_toggle = function() {
    self.shipping_toggle.on('change', self.check_shipping_toggle)
    self.check_shipping_toggle()
    self.website_toggle.on('change', self.check_website_toggle)
    self.check_website_toggle()
    self.affichettes_toggle.on('change', self.check_affichettes_toggle)
    self.check_affichettes_toggle()
    self.company_type_autre.on('change', self.check_company_type_toggle)
    self.check_company_type_toggle()
  }

  return function() {
    self.initialize_toggle()
    self.data('profile-form', self)
    return self
  }()
}
